<template>
  <component :is="colculatorName" :edit="edit"/>
</template>

<script>
import {ref} from "vue";
import {useRoute} from "vue-router";

export default {
  name: "CalculatorContainer",
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup() {
    const appVersion = ref(window.APP_VERSION);

    const route = useRoute();
    const version = ref((route.params?.version || window.APP_VERSION).replaceAll(".", ""));
    console.log('version!', version.value)
    const colculatorName = ref('Calculatorv' + version.value);
    return {
      colculatorName
    }
  }
}
</script>

<style scoped>

</style>